import React from "react";
import fp from "lodash/fp";

import { Button } from "components";

import { ReactComponent as ShowImage } from "static/images/eye.svg";
import { ReactComponent as HideImage } from "static/images/eye_hide.svg";
import styles from "./../splitProfile.module.scss";

const ToggleScheduleAButton = ({
	isUsedForCalculations,
	scheduleAFormState,
	showScheduleAData,
	setShowScheduleAData,
}) => {
	const handleClick = () => {
		setShowScheduleAData(!showScheduleAData);
	};

	return isUsedForCalculations && !fp.isEmpty(scheduleAFormState?.id) ? (
		<Button
			onClick={handleClick}
			icon={showScheduleAData ? <HideImage /> : <ShowImage />}
			btnIcon
			variant="secondary"
			title="Show Schedule A"
			className={styles.scheduleAResultBtn}
		/>
	) : null;
};

export default ToggleScheduleAButton;
